import { Balloon } from '~/app/(default-layout)/s/[storyId]/_components/chat-script-render/op/balloon';
import type { EndCall as EndCallOp } from '~/app/_types/chat-script';
import { Image, Paragraph } from '@styled-system/jsx';
import callEnd from './assets/call-end.png';

type Props = {
  op: EndCallOp;
};

export const EndCall = ({ op }: Props) => {
  return (
    <Balloon character={op.character} withTip>
      <Image
        src={callEnd}
        alt="通話終了"
        display="block"
        w="40px"
        h="40px"
        ml="7px"
      />
      <Paragraph mt="10px" textAlign="center" fontSize="size_14" minW="55px">
        通話
        <br />
        {op.durationText}
      </Paragraph>
    </Balloon>
  );
};
